<template>
  <v-card flat outlined class="grow patrol-card">
    <v-row dense class="flex-nowrap align-center mr-2" justify="start">
      <v-col cols="auto" class="shrink mr-1">
        <div>
          <user-avatar :user="patrol" small></user-avatar>
        </div>

      </v-col>
      <v-col cols="auto" class="shrink2 mx-1">
        <div>
          <task-status-icon v-if="task != null" :status="status" :stats="stats" class="mr-2"></task-status-icon>
          <task-status-icon v-if="task == null" :status="free" :stats="stats" class="mr-2"></task-status-icon>
        </div>
      </v-col>
      <v-col cols="auto" class="grow">
        <v-card-text v-if="true">
          <!-- Show final-status subtitle and comment similar to Timeline -->
          <template v-if="status && status.label_id === LabelId.ON_THE_WAY">
            <v-row dense align="center" class="no-gutters">
              <v-col>
                <v-progress-linear :value="travelProgress" color="primary" rounded />
              </v-col>
            </v-row>
            <v-row v-if="travelSummary" dense align="center" class="no-gutters">
              <v-col class="text-body-2">{{ travelSummary }}</v-col>
            </v-row>
          </template>
          <template v-else-if="status && status.label_id === LabelId.AT_LOCATION">
            <div class="text-headline-small">Czas dojazdu: {{ travelTimeString }}</div>
          </template>
          <template v-else-if="status && !isFinalStep">
            <!-- <div class="text-body">{{ status.message }}</div> -->
            <div v-if="!isFinalStep">{{ statusTitle }}</div>
          </template>
          <div v-if="statusSubtitle" class="text-body">{{ statusSubtitle }}</div>
          <v-tooltip bottom v-if="statusComment">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" class="status-comment text-body-2">{{ truncatedComment }}</div>
            </template>
            <div style="white-space: pre-wrap; max-width: 360px;">{{ statusComment }}</div>
          </v-tooltip>
        </v-card-text>
        <!-- <div v-if="progress"> -->
        <!-- <v-progress-linear :value="stats ? progress : 0" height="8" color="primary" rounded class="align-center" />
          <div class="text-caption mt-1" style="min-width: 80px; max-width: 220px;">
            {{ progress }}
          </div> -->
        <!-- </div> -->
      </v-col>
      <v-col cols="auto" class="shrink mx-1">
        <span v-if="nextStepButton">
          <v-divider vertical class="mx-1" />
          <tab-btn :text="nextStepButton.text" :icon="nextStepButton.icon" :highlighted="nextStepButton.isDeparture"
            @click="nextStepButton.action" />
        </span>
        <v-divider vertical class="mx-1" />
        <v-menu bottom left v-if="!readOnly">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" class="mx-2">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <!-- <v-list-item @click="foundUsers">
            <v-list-item-icon>
              <v-icon>mdi-account-check-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Osoba w obiekcie</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->

            <v-list-item @click="squadInfo">
              <v-list-item-icon>
                <v-icon>mdi-account-group-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Skład</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <span v-if="canCancel">
              <v-divider></v-divider>
              <v-list-item @click="cancelTask">
                <v-list-item-icon>
                  <v-icon>mdi-car-off</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Odwołaj</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>

            <span v-if="!readOnly">
              <v-divider></v-divider>
              <v-list-item @click="restartTask">
                <v-list-item-icon>
                  <v-icon>mdi-restore</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Rozpocznij od nowa</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </span>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <!-- <v-card-text class="py-0">
      <v-row align="center">
        <v-col class="ma-0" cols="12">
          <task-timeline :task="task" :site="site" :readOnly="readOnly" />
          <v-textarea dense v-model='comment' append-outer-icon='mdi-send' @click:append-outer="addComment" clearable
            autofocus filled type="text" @click:clear="comment = null" v-if="!isClose" outlined label="Komentarz"
            @keydown.enter.exact.prevent="addComment" @keydown.enter.shift.exact.prevent="addLineToComment" rows="1"
            auto-grow hide-details="auto" />
        </v-col>
      </v-row>
    </v-card-text> -->
    <v-divider v-if="true" />
    <v-card-actions v-if="true" align="center">
      <v-tooltip v-if="showTravelStats && arrivalTimeShort" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip small outlined color="secondary" class="font-weight-medium monospace mr-1" v-bind="attrs" v-on="on">
            <v-icon small left>mdi-map-marker</v-icon>
            {{ arrivalTimeShort }}
          </v-chip>
        </template>
        <div>Na miejscu: {{ arrivalDateTimeFull }}</div>
        <div>Czas dojazdu: {{ travelTimeDuration }}</div>
      </v-tooltip>
      <v-tooltip v-if="showTravelStats && travelDistanceFormatted" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip small outlined color="secondary" class="font-weight-medium monospace mr-1" v-bind="attrs" v-on="on">
            <v-icon small left>mdi-flag-checkered</v-icon>
            {{ travelDistanceFormatted }}
          </v-chip>
        </template>
        <div>Całkowity dystans podróży</div>
      </v-tooltip>
      <cost-chip v-if="cost != null" :color="cost.color" :text-color="cost.textColor" :name="cost.name" small />
      <v-spacer />
      <v-tooltip v-if="elapsedTimeString" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-chip small outlined color="secondary" class="font-weight-medium monospace mr-1" v-bind="attrs" v-on="on">
            <v-icon small left>mdi-clock-outline</v-icon>
            {{ elapsedTimeString }}
          </v-chip>
        </template>
        <div>Całkowity czas pracy</div>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
// import EventService from '@/services/event.service'
import {
  Labels, LabelId,
  patrolSummaryDialog, foundUsersDialog,
  firstAssigneeUser, isWaitingForPermission,
  descriptionForPatrol, getTaskCost
} from "@/store/modules/task"
import TaskService from "@/services/task.service"
import SiteService from "@/services/site.service"
import UserService from "@/services/user.service"
import patrolWorkingTimeCard from "./PatrolWorkingTimeCard.vue"
import patrolSummaryCard from "./PatrolSummaryCard.vue"
import notifyDialog from "@/components/NotifyDialog.vue"
// import TaskStatusChip from "./TaskStatusChip.vue"
import { sync } from 'vuex-pathify'
import { parseJSON } from "date-fns"

export default {
  // components: { TaskStatusChip },
  name: "PatrolCardMedium",

  beforeMount() {
    this.refreshNextButton();
    this.startElapsedTimer();
  },
  beforeDestroy() {
    this.stopElapsedTimer();
  },
  data() {
    return {
      comment: null,
      value: null,
      nextStepButton: null,
      elapsedTime: 0,
      elapsedTimer: null,
      LabelId: LabelId
    }
  },
  props: {
    site: {
      type: [Object, null],
      default: null
    },
    task: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    task() {
      this.refreshNextButton();
      this.resetElapsedTimer();
    }
  },
  computed: {
    user: sync('user.profile'),
    patrol() {
      return firstAssigneeUser(this.task)
    },
    cost() {
      return getTaskCost(this.task, this.$store)
    },
    stats() {
      // if (this.patrol?.tasks?.length === 0) {
      //   return null
      // }
      // return this.task?.details?.stats
      return {
        progress: 50,
      }
    },
    isFinalStep() {
      return Labels.isFinal(this.status?.label_id)
    },
    travelStartedAt() {
      return this.task?.details.stats?.travel_started_at
    },
    travelTime() {
      return this.task?.details?.stats?.travel_time
    },
    isStepOnTheWay() {
      return this.task?.details?.status?.label_id < LabelId.ON_THE_WAY
    },
    isStepOnPlace() {
      return this.task?.details?.status?.label_id == LabelId.ON_THE_WAY
    },
    isClose() {
      return this.task?.closed_at != null
    },
    isStepToClose() {
      return this.task?.details?.status?.label_id == LabelId.AT_LOCATION && !this.isClose
    },
    canEdit() {
      return this.user?.permissions?.task?.change && this.travelTime != null
    },
    canCancel() {
      if (this.isClose) return false
      if (this.task.details.status == null) return true
      const value = this.task.details.status.progress
      if ([LabelId.DONE, LabelId.POSITIVE, LabelId.NEGATIVE].includes(this.task.details.status.label_id)) {
        return false
      }
      return value >= 0 && value < 100
    },
    canRestart() {
      if (this.isClose) return false
      if (this.task.details.status == null) return false
      return this.task.details.status.progress > 0
    },
    status() {
      return this.task?.details?.status
    },
    statusMessage() {
      if (!this.status) {
        return null
      }
      let message = this.status.message
      if (this.status.comment) {
        message += ` - ${this.status.comment}`
      }
      if (Labels.isFinal(this.status.label_id)) {
        message = `(zamknięte)`
      }
      return message
    },
    statusSubtitle() {
      if (!this.status) return null
      if (Labels.isFinal(this.status.label_id)) {
        return this.status.message || 'Brak uwag końcowych'
      }
      return null
    },
    statusComment() {
      return this.status?.comment || null
    },
    truncatedComment() {
      const txt = this.statusComment || ''
      // prefer line-based truncation similar to timeline: show up to 3 lines
      const lines = txt.split(/\r?\n/)
      if (lines.length > 2) {
        return lines.slice(0, 2).join('\n') + '...'
      }
      // fallback to character limit
      const maxChars = 240
      if (txt.length > maxChars) {
        return txt.slice(0, maxChars) + '...'
      }
      return txt
    },
    statusColor() {
      if (!this.status) {
        return Labels.get(0).color(this.$vuetify.theme.dark)
      }
      return Labels.get(this.status.label_id).color(this.$vuetify.theme.dark)
    },
    statusTitle() {
      if (!this.status) {
        return descriptionForPatrol(Labels.get(0))
      }
      return descriptionForPatrol(this.status.label_id)
    },
    statusIcon() {
      if (!this.status) {
        return Labels.get(0).icon
      }
      return Labels.get(this.status.label_id).icon
    },
    statusProgress() {
      if (!this.status) {
        return 0
      }
      return this.status.progress
    },
    payment() {
      return this.$store.get('payments/findWithValue', (this.task.details.cost?.token ?? -1))
    },
    travelDistance() {
      return this.task?.details?.stats?.travel_distance ?? null
    },
    travelLeft() {
      return this.task?.details?.stats?.travel_left ?? null
    },
    travelProgress() {
      return this.task?.details?.stats?.travel_progress ?? this.statusProgress
    },
    travelTimeString() {
      const sec = this.travelTime ?? 0;
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = sec % 60;
      return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
    },
    elapsedTimeString() {
      const sec = this.elapsedTime;
      const h = Math.floor(sec / 3600);
      const m = Math.floor((sec % 3600) / 60);
      const s = sec % 60;
      return [h, m, s].map(v => String(v).padStart(2, '0')).join(':');
    },
    lastStatusChange() {
      return this.status?.updated_at || this.task?.updated_at || this.task?.created_at;
    },
    travelFinishedAt() {
      return this.task?.details?.stats?.travel_finished_at || null
    },
    arrivalTimeShort() {
      const arrivalTime = this.travelFinishedAt
      if (!arrivalTime) return null
      return this.$options.filters.timeShort(arrivalTime)
    },
    arrivalDateTimeFull() {
      const arrivalTime = this.travelFinishedAt
      if (!arrivalTime) return null
      return this.$options.filters.dateMediumTimeShort(arrivalTime)
    },
    travelTimeDuration() {
      const sec = this.travelTime
      if (!sec) return null
      return this.$options.filters.timeDuration(sec)
    },
    travelLeftFormatted() {
      const distance = this.travelLeft
      if (distance == null || distance === '' || distance === '--') return null
      return `${distance} km`
    },
    travelDistanceFormatted() {
      const distance = this.travelDistance
      if (distance == null || distance === '' || distance === '--') return null
      return `${distance} km`
    },
    travelSummary() {
      if (this.travelLeftFormatted && this.travelDistanceFormatted) {
        return `Pozostało: ${this.travelLeftFormatted} / ${this.travelDistanceFormatted}`
      }
      if (this.travelLeftFormatted) {
        return `Pozostało: ${this.travelLeftFormatted}`
      }
      if (this.travelDistanceFormatted) {
        return `Dystans: ${this.travelDistanceFormatted}`
      }
      return null
    },
    showTravelStats() {
      return Boolean(this.arrivalTimeShort || this.travelTimeDuration || this.travelDistanceFormatted)
    }
  },
  methods: {
    startElapsedTimer() {
      this.stopElapsedTimer();
      this.updateElapsedTime();
      this.elapsedTimer = setInterval(() => {
        this.updateElapsedTime();
      }, 1000);
    },
    stopElapsedTimer() {
      if (this.elapsedTimer) {
        clearInterval(this.elapsedTimer);
        this.elapsedTimer = null;
      }
    },
    resetElapsedTimer() {
      this.elapsedTime = 0;
      this.startElapsedTimer();
    },
    updateElapsedTime() {
      if (!this.lastStatusChange) {
        this.elapsedTime = 0;
        return;
      }
      // Parse the UTC date string and convert to local time
      const last = new Date(this.lastStatusChange + (this.lastStatusChange.includes('Z') ? '' : 'Z')).getTime();
      if (this.task.closed_at) {
        const closedAt = new Date(this.task.closed_at + (this.task.closed_at.includes('Z') ? '' : 'Z')).getTime();
        this.elapsedTime = Math.floor((closedAt - last) / 1000);
      } else {
        const now = Date.now();
        this.elapsedTime = Math.floor((now - last) / 1000);
      }
    },
    refreshNextButton() {
      const labelId = this.task?.details?.status?.label_id
      var nextLabel = null
      var nextAction = null
      var isDeparture = false
      if (labelId < LabelId.ON_THE_WAY) {
        nextLabel = Labels.get(LabelId.ON_THE_WAY)
        nextAction = this.onTheWay
      } else if (labelId == LabelId.ON_THE_WAY) {
        nextLabel = Labels.get(LabelId.AT_LOCATION)
        nextAction = this.onAtLocation
      } else if (labelId == LabelId.AT_LOCATION) {
        nextLabel = Labels.get(LabelId.DONE)
        nextAction = this.onSummary
      } else if ([LabelId.DONE, LabelId.POSITIVE, LabelId.NEGATIVE].includes(labelId) && !this.isClose) {
        if (isWaitingForPermission(this.task)) {
          nextLabel = {
            icon: 'mdi-car-arrow-right',
            action: "Odjazd"
          }
          nextAction = this.onAllowToClose
          isDeparture = true

        } else {
          nextLabel = Labels.get(LabelId.CLOSE)
          nextAction = this.onClose
        }
      }
      if (!nextAction) {
        this.nextStepButton = null
        return
      }
      this.nextStepButton = {
        icon: nextLabel.icon,
        text: nextLabel.action,
        action: nextAction,
        isDeparture: isDeparture
      }
    },
    onEditStats() {
      this.$router.push({
        name: "Edit Task Stats",
        params: {
          siteId: this.site.id,
          eventId: this.task.event,
          taskId: this.task.id,
          task: this.task
        }
      })
    },
    onTheWay() {
      const status = { label_id: LabelId.ON_THE_WAY, progress: 50 }
      TaskService.setStatus(this.site.id, this.task.id, status).then(res =>
        this.$emit("update:task", res.data)
      )
    },
    onAtLocation() {
      const status = { label_id: LabelId.AT_LOCATION, progress: 60 }
      TaskService.setStatus(this.site.id, this.task.id, status).then(res =>
        this.$emit("update:task", res.data)
      )
    },
    addComment() {
      if (!this.comment) {
        return
      }
      if (this.comment.trim().length == 0) {
        return
      }
      var lines = this.comment.split('\n');
      var comment = this.comment
      var more = null
      if (lines.length > 1) {
        comment = lines[0]
        lines.shift()
        more = lines.join('\n')
      }
      TaskService.addComment(this.site.id, this.task.id, comment, more).then(res => {
        this.$emit("update:task", res?.data)
        this.comment = null
      })

      // this.dispatcherTask.details.history.push({
      //   created_at: new Date().toISOString(),
      //   label_id: 300,
      //   comment: this.comment
      // })
      // this.comment = null
    },
    async foundUsers() {
      const args = {
        context: this,
        foundDialog: notifyDialog,
        taskService: TaskService,
        siteService: SiteService,
        site: this.site,
        task: this.task,
      }
      await foundUsersDialog(args).then(res => {
        if (res) {
          this.task.details.found.push(res.data)
        }
        this.$emit("update:task", res?.data)
      })
    },
    async onSummary() {
      await patrolSummaryDialog(this, patrolSummaryCard, TaskService, this.task, this.site).then(res => {
        this.$emit("update:task", res?.data)
      })
    },
    async onAllowToClose() {
      TaskService.allowToClosedTask(this.site.id, this.task.id).then(res =>
        this.$emit("update:task", res.data)
      )
    },
    async onClose() {
      const status = { label_id: LabelId.CLOSE }
      TaskService.setStatus(this.site.id, this.task.id, status).then(res =>
        this.$emit("update:task", res.data)
      )
    },
    async cancelTask() {
      const result = await this.$dialog.prompt({
        text: "Przyczyna",
        value: "",
        title: "Odwołanie patrolu",
        rules: [],
        actions: {
          false: "Anuluj",
          true: {
            color: "success",
            text: "Odwołaj"
          }
        }
      })
      if (result !== false && result != undefined) {
        TaskService.cancelTask(this.site.id, this.task.id, result).then(res =>
          this.$emit("update:task", res.data)
        )
      }
    },
    async restartTask() {
      const message = await this.$dialog.warning({
        text: "Czy chcesz zrestartować zadanie?",
        title: "Restart",
        actions: {
          false: "Nie",
          true: {
            color: "success",
            text: "Tak, chcę"
          }
        }
      })
      if (message) {
        TaskService.restartTask({siteId: this.site.id, taskId: this.task.id}).then(res =>
          this.$emit("update:task", res.data)
        )
      }
    },
    squadInfo() {
      const patrol = firstAssigneeUser(this.task)
      UserService.fetchPatrolSquad(patrol.id, parseJSON(this.task.created_at)).then(res => {
        const squad = res.data.results.map(time => time.user.email).join(", ")
        this.$dialog.show(patrolWorkingTimeCard, {
          readOnly: true,
          patrol: patrol,
          workingTimes: res.data.results,
          title: "Skład",
          text: squad
        })
      })
    }
  },
}
</script>

<style scoped>
.overlay {
  position: absolute;
  top: -12px;
  left: 8px;
  z-index: 1;
}
.monospace {
  font-family: 'Roboto Mono', monospace;
}
.status-comment {
  white-space: pre-wrap; /* preserve newlines */
}
</style>
